export default __webpack_public_path__ + "static/media/streak_fire_empty.51264f71.svg";